// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3eRXG","legacyBtn":"MutateMid_legacyBtn__12jYB"};